import { Typography } from "ots-components-library";

import type { Location } from "../../../types";

import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  selectActiveLocation,
  setActiveLocation,
} from "../../../redux/features/locationsSlice";

import "./LocationsListViewItem.scss";
import dayjs from "dayjs";

export interface LocationsListViewItemProps {
  location: Location;
  isFavorited: boolean;
  handleBookmarkClick: (
    unbookmarkLocationId: string,
    isUnbookmarkClick: boolean,
  ) => any;
}

function LocationsListViewItem({
  location,
  isFavorited,
  handleBookmarkClick,
}: LocationsListViewItemProps) {
  const {
    locationNumber,
    core: {
      locationName,
      physicalAddress: { city, state },
    },
    franchiseOpportunity: {
      operatorSelectionTimeline,
      recruitPhase1Date,
      recruitPhase5Date,
    },
  } = location;
  const activeLocation = useAppSelector(selectActiveLocation);

  const dispatch = useAppDispatch();

  const handleSelectClick = () => {
    if (activeLocation?.locationNumber === locationNumber) {
      dispatch(setActiveLocation(undefined));
    } else {
      dispatch(setActiveLocation(locationNumber));
    }
  };

  return (
    <li
      className={`location-list-item${
        activeLocation?.locationNumber === locationNumber ? " active" : ""
      }`}
      onClick={handleSelectClick}
    >
      <div className="item-border">
        <div className="item-text">
          <Typography variant="body1" color="primary" fontWeight="bold">
            {locationName}
          </Typography>
          <Typography
            variant="body2"
            color="secondary"
            fontWeight="medium"
          >{`${locationNumber} | ${city}, ${state}`}</Typography>
          <Typography variant="body2" fontWeight="medium">
            {operatorSelectionTimeline.includes("16")
              ? "Standard Selection (~16 weeks)"
              : "Multi-Restaurant First (~13 weeks)"}
          </Typography>
          <Typography variant="body2" fontWeight="medium">
            {`${dayjs(recruitPhase1Date).format("MMM DD, YYYY")} - ${dayjs(
              recruitPhase5Date,
            ).format("MMM DD, YYYY")}`}
          </Typography>
        </div>
        {/* <FavoriteIcon 
          locationId={location.locationNumber} 
          isFavorited={isFavorited}
          handleBookmarkClick={handleBookmarkClick}></FavoriteIcon> */}
      </div>
    </li>
  );
}

export default LocationsListViewItem;
